import React from 'react';
import { useHeaderStyles } from './styles/Header.styles';
import { isInTeams } from '../common/Teams';
import { isInShell } from '../common/Shell';
import { LoginButton } from './LoginButton';

const Header: React.FC = () => {
  const styles = useHeaderStyles();
  const inTeams = isInTeams();
  const inShell = isInShell();

  if (inTeams || inShell) {
    return null;
  }

  return (
    <header className={styles.headerBar}>
      <div className={styles.left}>
        <a href="/" className={styles.logoLink}>
          <span className={styles.logoText}>KANTAR</span>
        </a>
        <span className={styles.divider} />
        <span className={styles.depotText}>FILES</span>
      </div>
      <div className={styles.right}>
        <LoginButton />
      </div>
    </header>
  );
};

export default Header;
